module.exports = __webpack_public_path__ + "img/1f97e.a8c7977.svg";